import { Product } from '../types';

// ============================================
// FLASHER & RELAY BASE CONNECTORS
// ============================================

// 3 & 4 POLE FLASHER/RELAY BASE CONNECTORS
export const flasherRelayBase3_4PoleProducts: Product[] = [
  {
    id: "flasher-base-maruti-car-van-3p-f",
    name: "Universal Flasher Maruti Car/Van/Swift 3 Pole Female",
    slug: "flasher-base-maruti-car-van-swift-3-pole-female",
    category: "Flasher/Relay Base Connectors",
    subcategory: "3 & 4 Pole Flasher/Relay",
    description: "Universal flasher for Maruti Car/Van/Swift 3 pole female connector with 4mm deluxe wire.",
    partNumber: "SH0200301",
    image: "/products/flasher-relay-base/flasher-holder/SH0200301.jpg",
    featured: true,
    specifications: {
      "Poles": "3 Pole",
      "Gender": "Female",
      "Compatible": "Universal Flasher - Maruti Car, Van, Swift",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["flasher", "relay-base", "3-pole", "maruti", "car", "van", "swift", "female"],
    applications: ["Maruti Car", "Maruti Van", "Swift", "Flasher"],
  },
  {
    id: "relay-base-universal-4p-f-4-5mm-12v",
    name: "Universal Relay 4 Pole Female - 4mm & 5mm Wire (12V)",
    slug: "relay-base-universal-4-pole-female-4-5mm-12v",
    category: "Flasher/Relay Base Connectors",
    subcategory: "3 & 4 Pole Flasher/Relay",
    description: "Universal relay 4 pole female connector with 4mm & 5mm deluxe wire. 12V.",
    partNumber: "SH0200430",
    image: "/products/flasher-relay-base/relay-holder/SH0200430.jpg",
    featured: true,
    specifications: {
      "Poles": "4 Pole",
      "Gender": "Female",
      "Voltage": "12V",
      "Wire Type": "4mm & 5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["relay-base", "4-pole", "universal", "12v", "female"],
    applications: ["Universal Vehicles", "12V Relay"],
  },
  {
    id: "relay-base-universal-4p-f-special",
    name: "Universal Relay 4 Pole Female - Special & 5mm Wire",
    slug: "relay-base-universal-4-pole-female-special-5mm",
    category: "Flasher/Relay Base Connectors",
    subcategory: "3 & 4 Pole Flasher/Relay",
    description: "Universal relay 4 pole female connector with special & 5mm deluxe wire.",
    partNumber: "SH0200432",
    image: "/products/flasher-relay-base/relay-holder/SH0200432.jpg",
    specifications: {
      "Poles": "4 Pole",
      "Gender": "Female",
      "Wire Type": "Special & 5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["relay-base", "4-pole", "universal", "female"],
    applications: ["Universal Vehicles", "Relay"],
  },
  {
    id: "relay-base-universal-4p-f-5-7mm-12v",
    name: "Universal Relay 4 Pole Female - 5mm & 7mm Wire (12V)",
    slug: "relay-base-universal-4-pole-female-5-7mm-12v",
    category: "Flasher/Relay Base Connectors",
    subcategory: "3 & 4 Pole Flasher/Relay",
    description: "Universal relay 4 pole female connector with 5mm & 7mm deluxe wire. 12V.",
    partNumber: "SH0200428",
    image: "/products/flasher-relay-base/relay-holder/SH0200428.jpg",
    specifications: {
      "Poles": "4 Pole",
      "Gender": "Female",
      "Voltage": "12V",
      "Wire Type": "5mm & 7mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["relay-base", "4-pole", "universal", "12v", "female"],
    applications: ["Universal Vehicles", "12V Relay"],
  },
  {
    id: "relay-base-universal-4p-f-6-8mm-24v",
    name: "Universal Relay 4 Pole Female - 6mm & 8mm Wire (24V)",
    slug: "relay-base-universal-4-pole-female-6-8mm-24v",
    category: "Flasher/Relay Base Connectors",
    subcategory: "3 & 4 Pole Flasher/Relay",
    description: "Universal relay 4 pole female connector with 6mm & 8mm deluxe wire. 24V for commercial vehicles.",
    partNumber: "SH0200516",
    image: "/products/flasher-relay-base/relay-holder/SH0200516.jpg",
    specifications: {
      "Poles": "4 Pole",
      "Gender": "Female",
      "Voltage": "24V",
      "Wire Type": "6mm & 8mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["relay-base", "4-pole", "universal", "24v", "commercial", "female"],
    applications: ["Commercial Vehicles", "24V Systems", "Heavy Duty Relay"],
  },
  {
    id: "relay-base-micro-4p-f-4-5mm",
    name: "Universal Micro Relay 4 Pole Female - 4mm & 5mm Wire",
    slug: "relay-base-micro-4-pole-female-4-5mm",
    category: "Flasher/Relay Base Connectors",
    subcategory: "3 & 4 Pole Flasher/Relay",
    description: "Universal micro relay 4 pole female connector with 4mm & 5mm deluxe wire.",
    partNumber: "SH0200502",
    image: "/products/flasher-relay-base/relay-holder/SH0200502.jpg",
    specifications: {
      "Poles": "4 Pole",
      "Gender": "Female",
      "Type": "Micro Relay",
      "Wire Type": "4mm & 5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["relay-base", "4-pole", "micro", "universal", "female"],
    applications: ["Universal Vehicles", "Micro Relay"],
  },
  {
    id: "relay-base-universal-4p-f-24v",
    name: "Universal Relay 4 Pole Female - 4mm & 5mm Wire (24V)",
    slug: "relay-base-universal-4-pole-female-4-5mm-24v",
    category: "Flasher/Relay Base Connectors",
    subcategory: "3 & 4 Pole Flasher/Relay",
    description: "Universal relay 4 pole female connector with 4mm & 5mm deluxe wire. 24V.",
    partNumber: "SH0200520",
    image: "/products/flasher-relay-base/relay-holder/SH0200520.jpg",
    specifications: {
      "Poles": "4 Pole",
      "Gender": "Female",
      "Voltage": "24V",
      "Wire Type": "4mm & 5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["relay-base", "4-pole", "universal", "24v", "female"],
    applications: ["Commercial Vehicles", "24V Systems"],
  },
  {
    id: "relay-base-ac-4p-f-12v",
    name: "Universal AC Relay 4 Pole Female - 4mm & 5mm Wire (12V)",
    slug: "relay-base-ac-4-pole-female-4-5mm-12v",
    category: "Flasher/Relay Base Connectors",
    subcategory: "3 & 4 Pole Flasher/Relay",
    description: "Universal AC relay 4 pole female connector with 4mm & 5mm deluxe wire. 12V.",
    partNumber: "SH0200504",
    image: "/products/flasher-relay-base/relay-holder/SH0200504.jpg",
    specifications: {
      "Poles": "4 Pole",
      "Gender": "Female",
      "Type": "AC Relay",
      "Voltage": "12V",
      "Wire Type": "4mm & 5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["relay-base", "4-pole", "ac-relay", "universal", "12v", "female"],
    applications: ["Universal Vehicles", "AC System Relay"],
  },
];

// 5 POLE FLASHER/RELAY BASE CONNECTORS
export const flasherRelayBase5PoleProducts: Product[] = [
  {
    id: "relay-base-ac-5p-f-4-5mm",
    name: "Universal AC Relay 5 Pole Female - 4mm & 5mm Wire",
    slug: "relay-base-ac-5-pole-female-4-5mm",
    category: "Flasher/Relay Base Connectors",
    subcategory: "5 Pole Flasher/Relay",
    description: "Universal AC relay 5 pole female connector with 4mm & 5mm deluxe wire.",
    partNumber: "SH0200501",
    image: "/products/flasher-relay-base/relay-holder/SH0200501.jpg",
    featured: true,
    specifications: {
      "Poles": "5 Pole",
      "Gender": "Female",
      "Type": "AC Relay",
      "Wire Type": "4mm & 5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["relay-base", "5-pole", "ac-relay", "universal", "female"],
    applications: ["Universal Vehicles", "AC System Relay"],
  },
  {
    id: "relay-base-maximo-5p-f-3-4mm-12v",
    name: "Mahindra Maximo 5 Pole Female - 3mm & 4mm Wire (12V)",
    slug: "relay-base-maximo-5-pole-female-3-4mm-12v",
    category: "Flasher/Relay Base Connectors",
    subcategory: "5 Pole Flasher/Relay",
    description: "Mahindra Maximo 5 pole female relay connector with 3mm & 4mm deluxe wire. 12V.",
    partNumber: "SH0200511",
    image: "/products/flasher-relay-base/relay-holder/SH0200511.jpg",
    specifications: {
      "Poles": "5 Pole",
      "Gender": "Female",
      "Compatible": "Mahindra Maximo",
      "Voltage": "12V",
      "Wire Type": "3mm & 4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["relay-base", "5-pole", "maximo", "12v", "female"],
    applications: ["Mahindra Maximo", "Relay"],
  },
  {
    id: "relay-base-universal-5p-f-12v",
    name: "Universal Relay 5 Pole Female - 4mm & 5mm Wire (12V)",
    slug: "relay-base-universal-5-pole-female-4-5mm-12v",
    category: "Flasher/Relay Base Connectors",
    subcategory: "5 Pole Flasher/Relay",
    description: "Universal relay 5 pole female connector with 4mm & 5mm deluxe wire. 12V.",
    partNumber: "SH0200515",
    image: "/products/flasher-relay-base/relay-holder/SH0200515.jpg",
    featured: true,
    specifications: {
      "Poles": "5 Pole",
      "Gender": "Female",
      "Voltage": "12V",
      "Wire Type": "4mm & 5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["relay-base", "5-pole", "universal", "12v", "female"],
    applications: ["Universal Vehicles", "12V Relay"],
  },
  {
    id: "relay-base-universal-tata-5p-f-4-5mm",
    name: "Universal Relay Tata 5 Pole Female - 4mm & 5mm Wire",
    slug: "relay-base-universal-tata-5-pole-female-4-5mm",
    category: "Flasher/Relay Base Connectors",
    subcategory: "5 Pole Flasher/Relay",
    description: "Universal relay for Tata 5 pole female connector with 4mm & 5mm deluxe wire.",
    partNumber: "SH0200525",
    image: "/products/flasher-relay-base/relay-holder/SH0200525.jpg",
    specifications: {
      "Poles": "5 Pole",
      "Gender": "Female",
      "Compatible": "Universal Relay Tata",
      "Wire Type": "4mm & 5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["relay-base", "5-pole", "universal", "tata", "female"],
    applications: ["Tata Vehicles", "Relay"],
  },
  {
    id: "relay-base-universal-5p-f-4-5mm",
    name: "Universal Relay 5 Pole Female - 4mm & 5mm Wire",
    slug: "relay-base-universal-5-pole-female-4-5mm",
    category: "Flasher/Relay Base Connectors",
    subcategory: "5 Pole Flasher/Relay",
    description: "Universal relay 5 pole female connector with 4mm & 5mm deluxe wire.",
    partNumber: "SH0200520",
    image: "/products/flasher-relay-base/relay-holder/SH0200520.jpg",
    specifications: {
      "Poles": "5 Pole",
      "Gender": "Female",
      "Wire Type": "4mm & 5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["relay-base", "5-pole", "universal", "female"],
    applications: ["Universal Vehicles", "Relay"],
  },
  {
    id: "relay-base-universal-5p-f-5-6mm-24v",
    name: "Universal Relay 5 Pole Female - 5mm & 6mm Wire (24V)",
    slug: "relay-base-universal-5-pole-female-5-6mm-24v",
    category: "Flasher/Relay Base Connectors",
    subcategory: "5 Pole Flasher/Relay",
    description: "Universal relay 5 pole female connector with 5mm & 6mm deluxe wire. 24V for commercial vehicles.",
    partNumber: "SH0200516",
    image: "/products/flasher-relay-base/relay-holder/SH0200516.jpg",
    specifications: {
      "Poles": "5 Pole",
      "Gender": "Female",
      "Voltage": "24V",
      "Wire Type": "5mm & 6mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["relay-base", "5-pole", "universal", "24v", "commercial", "female"],
    applications: ["Commercial Vehicles", "24V Systems"],
  },
  {
    id: "relay-base-micro-5p-f-4-5mm",
    name: "Universal Micro Relay 5 Pole Female - 4mm & 5mm Wire",
    slug: "relay-base-micro-5-pole-female-4-5mm",
    category: "Flasher/Relay Base Connectors",
    subcategory: "5 Pole Flasher/Relay",
    description: "Universal micro relay 5 pole female connector with 4mm & 5mm deluxe wire.",
    partNumber: "SH0200504",
    image: "/products/flasher-relay-base/relay-holder/SH0200504.jpg",
    specifications: {
      "Poles": "5 Pole",
      "Gender": "Female",
      "Type": "Micro Relay",
      "Wire Type": "4mm & 5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["relay-base", "5-pole", "micro", "universal", "female"],
    applications: ["Universal Vehicles", "Micro Relay"],
  },
];
